import { useEffect, useState } from "react";
import "./translater.css"; // Import your CSS file

const GoogleTranslateLoader = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  useEffect(() => {
    if (!document.getElementById("google-translate-script")) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          { pageLanguage: "en", autoDisplay: false },
          "google_translate_element"
        );
      };
    }
  }, []);

  const changeLanguage = (lang) => {
    setSelectedLanguage(lang);
    const googleFrame = document.querySelector(".goog-te-combo");
    if (googleFrame) {
      googleFrame.value = lang;
      googleFrame.dispatchEvent(new Event("change"));
    }
  };

  return (
    <div>
      {/* Custom Dropdown at the Bottom */}
      <div className="sticky-translate">
        <select
          value={selectedLanguage}
          onChange={(e) => changeLanguage(e.target.value)}
          style={{
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          <option value="en">English</option>
          <option value="si">Sinhala</option>
          <option value="ta">Tamil</option>          
        </select>
      </div>

      {/* Google Translate Hidden */}
      <div id="google_translate_element" style={{ display: "none" }}></div>
    </div>
  );
};

export default GoogleTranslateLoader;
